export default 'M59.9,10.1c6.6,6.6,9.9,14.8,10.1,24.8-1.4,14.2-7.2,28.3-17.5,42.3S36.4,98.7,35,99.8c-1.4-1.1-7.2-8.6-17.5-22.6S1.4,49.1,0,34.9c.2-10,3.5-18.3,10.1-24.8S24.9.2,34.9,0C45,.2,53.3,3.6,59.9,10.1Zm-16,33.8A12.13,12.13,0,0,0,47.4,35,12,12,0,0,0,35,22.6,12,12,0,0,0,22.6,35,12,12,0,0,0,35,47.4,12.13,12.13,0,0,0,43.9,43.9Z'



// WEBPACK FOOTER //
// ./src/mixins/addon.js